import React from 'react';
import { getCloudinaryPath } from '~/utils';

function Image({src, alt, transformation, ...props}) {
  return <img src={getCloudinaryPath(src, transformation)} alt={alt} {...props} />;
}

export default Image;
